import { render, staticRenderFns } from "./interactiveQuiz.vue?vue&type=template&id=3c48baf4&scoped=true"
import script from "./interactiveQuiz.vue?vue&type=script&lang=js"
export * from "./interactiveQuiz.vue?vue&type=script&lang=js"
import style0 from "./interactiveQuiz.vue?vue&type=style&index=0&id=3c48baf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48baf4",
  null
  
)

export default component.exports